import { render, staticRenderFns } from "./ManagePortalUsers.vue?vue&type=template&id=3c767ee1&"
import script from "./ManagePortalUsers.vue?vue&type=script&lang=js&"
export * from "./ManagePortalUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports